module.exports = __webpack_public_path__ + "img/linked-cards-new.7562cb73.svg";